import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { documentSubmitStageValidation } from "../../../schemas";
import {
  POST_UPDATE_RECRUITMENT_CANDIDATE_URL,
  UPLOAD_REFERENCE_DOCUMENT_URL,
  ADMIN_AUTH_TOKEN,
  BASE_URL,
  ADMIN_ID
} from "../../../env";
import {
  postRecords,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
  catchAsync,
} from "../../../helper/helper";
import TextArea from "../../../components/forms-fields/TextArea";

function DocSubmitProcessPopup({ recCandidateDetail, subModalViewCarePlans }) {
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [fileSizeError, setFileSizeError] = useState({});
  const [uploadedFileLink, setUploadedFileLink] = useState(false);
  const [isRecrUserData, setIsRecrUserData] = useState(false);
  const [commentBox, setCommentBox] = useState("");
  const handleClose = () => {
    subModalViewCarePlans(subModalViewCarePlans);
  };

  const [documentSubmitFormFields] = useState([
    { id: 1, name: "photographicIdentification", label: "Photographic Identification", documentEnum: "photographicIdentification" },
    { id: 2, name: "proofOfAddress", label: "Proof of Address", documentEnum: "proofOfAddress" },
    { id: 3, name: "rightToWork", label: "Right to work", documentEnum: "rightToWork" },
    { id: 4, name: "proofOfNationalInsurance", label: "Proof of National Insurance", documentEnum: "proofOfNationalInsurance" },
    { id: 5, name: "otherdocumentSubmitDoc", label: "Other Document", documentEnum: "otherdocumentSubmitDoc" },

  ]);

  const [documentSubmitUploadedDoc, setDocumentSubmitUploadedDoc] = useState([
    { documentEnum: "photographicIdentification", path: "", title: "Photographic Identification", docType: "documentSubmitDoc", },
    { documentEnum: "proofOfAddress", path: "", title: "Proof of Address", docType: "documentSubmitDoc", },
    { documentEnum: "rightToWork", path: "", title: "Right to work", docType: "documentSubmitDoc", },
    { documentEnum: "proofOfNationalInsurance", path: "", title: "Proof of National Insurance", docType: "documentSubmitDoc", },
    { documentEnum: "otherdocumentSubmitDoc", path: "", title: "Other Document", docType: "documentSubmitDoc", },
  ]);

  useEffect(() => {

    if (recCandidateDetail?.documentSubmitDoc?.length > 0) {
      setDocumentSubmitUploadedDoc(recCandidateDetail.documentSubmitDoc);
    }
  }, [recCandidateDetail]);

  const [suFormData, setSuFormData] = useState({
    recruitId: recCandidateDetail?._id || "",
    photographicIdentification: recCandidateDetail.documentSubmitDoc[0]?.path || "",
    proofOfAddress: recCandidateDetail.documentSubmitDoc[1]?.path || "",
    rightToWork: recCandidateDetail.documentSubmitDoc[2]?.path || "",
    proofOfNationalInsurance: recCandidateDetail.documentSubmitDoc[3]?.path || "",
    commentBox: "",

  });
  // console.log("🚀 ~ DocSubmitProcessPopup ~ suFormDatasuFormDatasuFormData:", suFormData)
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: documentSubmitStageValidation,
    onSubmit: async (values) => {
      try {
        setIsSubmitButtonClicked(true);
        await postAddCarePlansFormData(values);
      } catch (error) {

      }
    },
  });

  const processPostRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsRecrUserData(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
    } else if (method === "postAddCarePlansFormData" && data?.status === isSuccess) {
      setIsRecrUserData(true);
      toastSuccessMessages(toast.success, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
        handleClose();
      }, 2000);
    }
  };

  const postAddCarePlansFormData = catchAsync(async (req, res) => {
    const updateValues = {
      ...values,
      documentSubmitDoc: documentSubmitUploadedDoc,
      notes: [
        ...recCandidateDetail?.notes,
        ...(commentBox !== "" ? [{
          staffId: ADMIN_ID,
          note: commentBox,
          process: recCandidateDetail?.processStatus,
        }] : [])
      ],
    };

    const response = await postRecords(POST_UPDATE_RECRUITMENT_CANDIDATE_URL, updateValues);
    setIsSubmitButtonClicked(false);
    processPostRecords("postAddCarePlansFormData", response);
  });

  const handleFileUpload = async (e, documentEnum, settingTheArray) => {
    setIsSubmitButtonClicked(true);
    try {
      const file = e.target.files[0];
      const fileName = file.name;
      const fileType = file.type;
      const fileSize = file.size;

      // Check file size (5MB = 1048576 bytes)
      if (fileSize > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB');
        setFileSizeError(prev => ({ ...prev, [documentEnum]: true }));
        setIsSubmitButtonClicked(false);
        return;
      } else {
        // Clear any previous error for this field
        setFileSizeError(prev => ({ ...prev, [documentEnum]: false }));
      }

      // Check file type
      const acceptedFileTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/jpg',
        'image/svg+xml'
      ];

      if (acceptedFileTypes.includes(fileType)) {
        const fileData = new FormData();
        fileData.append('attachements', file);

        const apiResponse = await fetch(UPLOAD_REFERENCE_DOCUMENT_URL, {
          method: 'POST',
          body: fileData,
          headers: {
            Authorization: `Bearer ${ADMIN_AUTH_TOKEN}`,
          },
        });

        const resultResponse = await apiResponse.json();
        // console.log("🚀 ~ handleFileUpload ~ resultResponse:", resultResponse)
        const fileLink = `${resultResponse?.data[0]?.fileNameInDirectory}`;
        setUploadedFileLink(fileLink);

        settingTheArray((prevValues) =>
          prevValues.map((doc) =>
            doc.documentEnum === documentEnum ? { ...doc, path: fileLink, docType: "documentSubmitDoc", } : doc
          )
        );
      } else {
        alert('Unsupported file format');
      }

      setIsSubmitButtonClicked(false);
    } catch (error) {
      console.error('Error uploading file:', error);
      setIsSubmitButtonClicked(false);
    }
  };

  useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      documentSubmitDoc: documentSubmitUploadedDoc,
    }));
  }, [documentSubmitUploadedDoc]);

  return (
    <>
      <main>
        <form onSubmit={handleSubmit} encType="multipart/form-data">

          <div className="row">

            {recCandidateDetail?.processStatus === 'documentSubmit' &&
              recCandidateDetail.documentSubmitDoc.length >= 4 && (
                <>
                  <div className="col-md-12">
                    <p>
                      <strong>Attached Documents</strong>
                    </p>
                    <div className="attachedDocumentWrapper">
                      {
                        documentSubmitUploadedDoc.map((item, index) => (
                          item?.path !== "" && (
                            <div key={index} className="alert alert-secondary" role="alert">
                              <a target="_blank" href={`${BASE_URL}${item?.path}`}>{item?.title}</a>
                            </div>
                          )
                        ))
                      }
                    </div>
                  </div>
                </>
              )}

            <div className="col-md-12 mt-5">
              <p>
                <strong>Attach required documents</strong>
                <small>Please upload a file that is 5MB or smaller.</small>
              </p>
            </div>
            {documentSubmitFormFields.map((item, index) => (
              <div key={index} className="col-md-12">
                <div className="form-group">
                  <input
                    name={item.name}
                    id={item.name}
                    type="file"
                    accept=".jpg,.jpeg,.pdf,.doc,.docx,.svg"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      handleFileUpload(e, item.documentEnum, setDocumentSubmitUploadedDoc);
                    }}
                  />
                  <label htmlFor={item.name} className="floatingLabel">
                    {item.label}
                    {
                      item.documentEnum !== "otherdocumentSubmitDoc" && (
                        <span className="text-danger">*</span>
                      )
                    }
                  </label>
                  {errors[item.name] && touched[item.name] && (
                    <div className="validationError">
                      <div className="text-danger">{errors[item.name]}</div>
                    </div>
                  )}
                  {fileSizeError[item?.documentEnum] && (
                    <div className="validationError">
                      <div className="text-danger">
                        Error: File size exceeds the 5MB limit. Please upload a smaller file.
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}

            <div className="col-md-12">
              <TextArea
                name="commentBox"
                value={commentBox}
                onChange={(e) => { setCommentBox(e.target.value); handleChange(e); }}
                onBlur={handleBlur}
                cols={5}
                rows={5}
                labelText="Notes"

              />
            </div>
          </div>
          <div className="formActionButtons">
            {isSubmitButtonClicked ? (
              <Button
                onClick={handleClose}
                className="btn-sm"
                variant="primary"
                disabled
              >
                Loading...
              </Button>
            ) : (
              <Button className="btn-sm" variant="primary" type="submit">
                Save
              </Button>
            )}
            <span
              onClick={handleClose}
              className="btn btn-sm btn-outline-primary"
            >
              Close
            </span>
          </div>
        </form>
      </main>
      {isRecrUserData && <ToastContainer />}
    </>
  );
}

export default DocSubmitProcessPopup;
